import { render, staticRenderFns } from "./province.vue?vue&type=template&id=7c035d12&scoped=true"
import script from "./province.vue?vue&type=script&lang=js"
export * from "./province.vue?vue&type=script&lang=js"
import style0 from "./province.vue?vue&type=style&index=0&id=7c035d12&prod&scoped=true&lang=css"
import style1 from "./province.vue?vue&type=style&index=1&id=7c035d12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c035d12",
  null
  
)

export default component.exports